import React from "react"

import DataIcon from "@components/elements/V2/Icons/DataIcon"
import DesignIcon from "@components/elements/V2/Icons/DesignIcon"
import FinanceIcon from "@components/elements/V2/Icons/FinanceIcon"
import OperationsIcon from "@components/elements/V2/Icons/OperationsIcon"
import PeopleIcon from "@components/elements/V2/Icons/PeopleIcon"
import ProductIcon from "@components/elements/V2/Icons/ProductIcon"
import SalesIcon from "@components/elements/V2/Icons/SalesIcon"
import TechnologyIcon from "@components/elements/V2/Icons/TechnologyIcon"

type DepartmentIcon = React.ComponentType<{ className?: string }>

export const getDepartmentIcon = (department: string): DepartmentIcon => {
  switch (department.trim().toLowerCase()) {
    case "engineering":
      return TechnologyIcon
    case "design":
      return DesignIcon
    case "product":
      return ProductIcon
    case "sales":
      return SalesIcon
    case "operations":
      return OperationsIcon
    case "finance":
      return FinanceIcon
    case "people":
      return PeopleIcon
    case "data":
      return DataIcon
    default:
      return TechnologyIcon
  }
}
